import {createSharedValueKey} from '@epic-core/hooks';

export const IndustrySelected = createSharedValueKey('industrySelected', '');
